import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installElementPlus from './plugins/element'
import Paginate from 'vuejs-paginate'





const app = createApp(App)
installElementPlus(app)
app.use(store,Paginate).use(router).mount('#app')